import React from "react";
import Content2024 from "../content2024";
import Footer from "../Footer";

function Productions2024() {
  return (
    <div className="page-wrapper">
      <Content2024 />
      <br></br>
      <Footer />
    </div>
  );
}

export default Productions2024;
